/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ZboziIntegrationData
 */
export interface ZboziIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof ZboziIntegrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ZboziIntegrationData
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ZboziIntegrationData
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ZboziIntegrationData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ZboziIntegrationData
     */
    project?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ZboziIntegrationData
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ZboziIntegrationData
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ZboziIntegrationData
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ZboziIntegrationData
     */
    lastHistoricalUpdate?: string | null;
}

/**
 * Check if a given object implements the ZboziIntegrationData interface.
 */
export function instanceOfZboziIntegrationData(value: object): value is ZboziIntegrationData {
    return true;
}

export function ZboziIntegrationDataFromJSON(json: any): ZboziIntegrationData {
    return ZboziIntegrationDataFromJSONTyped(json, false);
}

export function ZboziIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZboziIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'project': json['project'] == null ? undefined : json['project'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] == null ? undefined : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] == null ? undefined : json['lastHistoricalUpdate'],
    };
}

export function ZboziIntegrationDataToJSON(json: any): ZboziIntegrationData {
    return ZboziIntegrationDataToJSONTyped(json, false);
}

export function ZboziIntegrationDataToJSONTyped(value?: ZboziIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'project': value['project'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
    };
}

